import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, of, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BdUtilScriptService {
  private document = inject<Document>(DOCUMENT);
  private readonly rendererFactory = inject(RendererFactory2);

  private _scriptsLoaded: { [key: string]: boolean } = {};

  public removeJsScript(id: string): void {
    if (this._scriptsLoaded[id]) {
      delete this._scriptsLoaded[id];

      this.document.getElementById(id).remove();
    }
  }

  /**
   * Append the JS tag to the Document Body.
   * @returns the script element
   */
  public loadJsScript(
    obj: Partial<HTMLScriptElement>,
    attributes: [string, string][] = [],
    parentElement: HTMLElement = this.document.body,
  ): Observable<HTMLElement> {
    const load$ = new Subject<HTMLElement>();

    if (this._scriptsLoaded[obj.id]) {
      return of(this.document.getElementById(obj.id));
    }

    const script: HTMLScriptElement = this._renderer().createElement('script');
    script.id = obj.id;
    script.type = 'text/javascript';
    script.src = obj.src;
    attributes.forEach((it) => script.setAttribute(it[0], it[1]));

    script.onload = () => {
      load$.next(script);
    };

    script.onerror = () => {
      console.error(`Error loading script url: ${obj.src}`);
      load$.error(script);
    }

    this._scriptsLoaded[obj.id] = true;
    this._renderer().appendChild(parentElement, script);

    return load$;
  }

  private _renderer(): Renderer2 {
    return this.rendererFactory.createRenderer(null, null);
  }
}
